module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.currentAlert),
      callback: function($$v) {
        _vm.currentAlert = $$v
      },
      expression: "currentAlert"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Job already in progress")]), _vm._v(" "), _c('v-card-text', [_vm._v("There is already a job in progress, by creating a new job you will lose any progress. Are you sure\n        you want discard the current job?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.discardCurrentJob.apply(null, arguments)
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": "",
      "to": "/CurrentJob"
    }
  }, [_vm._v("Continue")])], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-flex', {
    attrs: {
      "xs-12": ""
    }
  }, [_c('v-card', [_c('v-container', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Customer",
      "items": _vm.customers,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "no-data-text": "No Results - Please type at least 3 characters",
      "rules": _vm.customerRules,
      "search-input": _vm.customerFilter,
      "loading": _vm.customerLoading
    },
    on: {
      "update:searchInput": function($event) {
        _vm.customerFilter = $event
      },
      "update:search-input": function($event) {
        _vm.customerFilter = $event
      }
    },
    model: {
      value: (_vm.currentJob.Customer),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "Customer", $$v)
      },
      expression: "currentJob.Customer"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Vehicle Registration",
      "items": _vm.vehicles,
      "item-text": "VehicleReg",
      "item-value": "VehicleReg",
      "return-object": false,
      "required": "",
      "rules": _vm.vehicleRules
    },
    model: {
      value: (_vm.currentJob.Vehicle),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "Vehicle", $$v)
      },
      expression: "currentJob.Vehicle"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "IMEI Number",
      "type": "number"
    },
    model: {
      value: (_vm.currentJob.imei),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "imei", $$v)
      },
      expression: "currentJob.imei"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Checklists required")]), _vm._v(" "), _vm._l((_vm.templates), function(item, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "label": item.name,
        "disabled": !item.optional
      },
      model: {
        value: (item.required),
        callback: function($$v) {
          _vm.$set(item, "required", $$v)
        },
        expression: "item.required"
      }
    })
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.valid,
      "block": "",
      "color": "success",
      "loading": _vm.creating
    },
    on: {
      "click": _vm.createJob
    }
  }, [_vm._v("\n              Create Job\n            ")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.duplicateDialog),
      callback: function($$v) {
        _vm.duplicateDialog = $$v
      },
      expression: "duplicateDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Job already in system")]), _vm._v(" "), _c('v-card-text', [_vm._v("A job for this vehicle is already present in the system. Do you want use the orriginal or\n          continue to create a new job?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.confirmAndCreate
    }
  }, [_vm._v("Create New")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.createFromOGJob
    }
  }, [_vm._v("Keep Original")])], 1)], 1)], 1), _vm._v(" "), _c('disclaimer-dialog', {
    attrs: {
      "dialog": _vm.disclaimerDialog
    },
    on: {
      "update:dialog": function($event) {
        _vm.disclaimerDialog = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58da891a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateJob.vue
// module id = 674
// module chunks = 1